import IndustrySolutionI18n from "@/components/landing/shared/IndustrySolutionI18n";
import { Clock, Headphones, BookOpen, Zap } from "lucide-react";
const LoesungITSection = () => <IndustrySolutionI18n translationPrefix="industryIT" icons={[Clock, Headphones, BookOpen, Zap]} />;
export default LoesungITSection;
